import { useContext } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { useNavigate } from '@namespace/router';
import { USER_ROLES, UserContext } from '@namespace/user';
import { wheelActions } from '../store';

const { SET_WHEEL_STATE } = wheelActions;

export const useOpenModalWithRedirect = () => {
  const { login } = useGeneralRoutes();
  const navigate = useNavigate();

  const [user] = useContext(UserContext);
  const { role, userInfoLoaded } = user;

  const onClickWheel = () => {
    if (userInfoLoaded && role !== USER_ROLES.USER) {
      navigate(login);

      return;
    }

    SET_WHEEL_STATE(true);
  };

  return { onClickWheel };
};
